import React from "react";
import { getPdfRenderer } from "../../getPdfRenderer";




export class PdfImageCache extends Map<string, string> { // z.B. DataURL, Blob, Uint8Array

    addImage(id: string, url: string) {
        if (this.has(id)) return; // Nur einmal hinzufügen  
        this.set(id, url);
    }

}

export const pdfImageCache = new PdfImageCache();

/**
 * Invisible anchor for PDF image referencing.
 * Usage: <AnchorBox id={imageId} />
 */
export default function PdfImagePlaceholder(props: { id: string, style?: any, url: string }) {

    const { id, url, style } = props;
    pdfImageCache.addImage(id, url);

    const xStyle: any = {
        position: 'absolute',
        left: style?.left || 0,
        top: style?.top || 0,
        opacity: 0
    }

    if (style?.width || style?.height) {
        xStyle.width = style?.width || 0;
        xStyle.height = style?.height || 0;
    } else {
        xStyle.right = 0;
        xStyle.bottom = 0;
    }

    const pdf = getPdfRenderer();
    if (!pdf) return null;

    const { Link } = pdf;



    return (
        <Link src={`estada://img/${id}`} style={xStyle} />
    );
};

